<template>
  <div v-if="training._id">
    <div class="page-title underline mb-4"><mdb-icon icon="calendar-day" /> 훈련 일지</div>
    <mdb-row>
      <mdb-col md="3" class="">
        <v-calendar ref="calendar" class="date-picker px-0" is-expanded
            :attributes="attributes" @dayclick="onDayClick"/>
      </mdb-col>
      <mdb-col md="9">
        <div class="clearfix">
          <div class="sub-title float-left">
            <mdb-icon icon="calendar-day" /> 날짜: {{$strDate(log.logDate)}}
            <mdb-badge v-if="isNew" color="danger">New</mdb-badge>
          </div>
          <div class="title float-right">
            <mdb-btn icon="arrow-alt-circle-left" class="p-1" @click="onMoveDate(training.startDate)">첫 번째 일지</mdb-btn>
            <mdb-btn icon="arrow-alt-circle-right" class="p-1" @click="onMoveDate(training.endDate)">마지막 일지</mdb-btn>
            <mdb-btn icon="check" class="p-1" @click="onMoveToday()">오늘</mdb-btn>
            <mdb-btn icon="save" class="p-1" @click="onSave">저장</mdb-btn>
            <mdb-btn icon="times" class="p-1" color="red" @click="onDelete" :disabled="!log._id">삭제</mdb-btn>
          </div>
        </div>
        <mdb-row>
          <mdb-col md="4" class=""><mdb-input label="강사" v-model="log.teacher.name"/></mdb-col>
          <mdb-col offsetMd="3" md="1" class=""><mdb-input type="number" label="재적" v-model="log.present"/></mdb-col>
          <mdb-col md="1" class=""><mdb-input type="number" label="출석" v-model="log.attendance"/></mdb-col>
          <mdb-col md="1" class=""><mdb-input type="number" label="결석" v-model="log.absence"/></mdb-col>
          <mdb-col md="1" class=""><mdb-input type="number" label="지각" v-model="log.lateness"/></mdb-col>
          <mdb-col md="1" class=""><mdb-input type="number" label="조퇴" v-model="log.earlyLeave"/></mdb-col>
        </mdb-row>

        <div class="title"><mdb-icon icon="check-square" /> 강의주제</div>
        <mdb-input type="textarea" class="mt-1" :rows="4" v-model="log.topic"/>
        <div class="title"><mdb-icon icon="check-square" /> 강의내용</div>
        <mdb-input type="textarea" class="mt-1" :rows="4" v-model="log.content"/>
        <div class="title"><mdb-icon icon="check-square" /> 요청사항</div>
        <mdb-input type="textarea" class="mt-1" :rows="4" v-model="log.request"/>
        <div class="title"><mdb-icon icon="check-square" /> 특이사항</div>
        <mdb-input type="textarea" class="mt-1" :rows="4" v-model="log.etc"/>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import DailyLog from '@/models/DailyLog'
export default {
  name: 'DailyLogPage',
  components: { },
  data: () => ({
    teacher: {}, // 강사 ID
    logs: [],
    log: { teacher: {} },
    date: new Date(),
    today: new Date(),
    attributes: [],
    availableDates: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training']),
    isStudy () {
      return this.$moment(this.logDate.date).isBetween(this.training.startDate, this.training.endDate)
    },
    isNew () {
      return this.log && !this.log._id
    }
  },
  methods: {
    // 지정한 날짜의 로그 리턴
    // 없으면 새로운 모델 인스턴스 리턴
    getLog (date) {
      const logDate = this.$strDate(date)
      return this.logs[logDate] || DailyLog.create(this.training, this.teacher, date)
    },
    // 클릭한 날짜로 이동
    async onDayClick (date) {
      this.log = this.getLog(date.date)
    },
    // 지정한 날짜로 이동
    async onMoveDate (date) {
      const calendar = this.$refs.calendar
      await calendar.move(date)
      this.log = this.getLog(date)
    },
    // 오늘 날짜로 이동
    async onMoveToday () {
      const calendar = this.$refs.calendar
      const today = new Date()
      await calendar.move(today)
      this.log = this.getLog(today)
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      await this.log.save()
      this.logs[this.$strDate(this.log.logDate)] = this.log
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      await this.log.delete(this.log._id);
      delete this.logs[this.$strDate(this.log.logDate)]
      this.log = DailyLog.create(this.training, this.teacher, this.log.logDate)
    },
    async load () {
      if (!this.training._id) return;
      this.teacher = this.profile
      const { _id, startDate, endDate } = this.training
      const data = await DailyLog.list({ training: _id });
      this.attributes = [
        { key: 'today', highlight: 'purple', dates: new Date() },
        { key: 'startDay', highlight: 'red', dates: this.$strDate(startDate) },
        { key: 'endEndDay', highlight: 'red', dates: this.$strDate(endDate) }
      ]
      this.availableDates = { start: startDate, end: endDate }
      this.logs = data.reduce((acc, cur) => {
        const logDate = this.$strDate(cur.logDate)
        acc[logDate] = cur
        this.attributes.push({
          key: 'logday', highlight: 'yellow', dates: this.$strDate(logDate)
        })
        return acc;
      }, {})
      this.onMoveToday()
    }
  },
  watch: { training: 'load' },
  created () { this.load() }
}
</script>
